import React from "react";
import BettingDashboardMix from "./BettingDashboardMix";
import StatisticTableMix from "./StatisticTableMix";
import TabView from "../../lotto/TabView";
import RecentOrdering from "../RecentOrdering";
import RecentBetting from "../RecentBetting";
import {isOddEven, pfType999Color} from "../../../constants/general";
import {useLotto5} from "../../../store/lotto5/Lotto5Context";


export default () => {
    const lotto = useLotto5();
    const {
        t, lastResult: {
            oddEvenCode, underOverCode, number, result, drawLabel
        },
        platform,
    } = lotto;

    const tabs = [
        t("labels:drawing.betting"),
        t("labels:drawing.result")
    ];
    const children = [
        <>
            <RecentOrdering/>
            <RecentBetting/>
        </>,
        <StatisticTableMix/>
    ]

    return <div className="lotto5-mix">
        {/*    /!* betting dashboard and pricing *!/*/}
        <BettingDashboardMix/>
        {/*    /!* end of betting dashboard and pricing *!/*/}
        <div
            className={"col-12 header header-div-title-mix header-text fade-in loading-gif-" + platform + " " + pfType999Color}>
                            <span
                                className="text-white">{drawLabel}</span>
            {
                underOverCode ?
                    <span
                        className="text-white fade-in">{t("labels:betPrefix." + underOverCode) + "  /   " + (isOddEven ? t("labels:betPrefix." + oddEvenCode) + " / " : "") + t("labels:betPrefix." + number) + "   /   " + result}</span>
                    : <span className="text-white fade-in"/>
            }

        </div>
        <div className="tab-view border-all">
            <TabView children={children} tabs={tabs}/>
        </div>
    </div>
}